import { createSelector } from 'reselect';
import {  mapTagsLocationName } from '../transform';

const allTags = state => mapTagsLocationName(state.tags.data);

/**
  @name getAllUnfilteredTags
  Selector to obtain the unfiltered and sorted list of all tags
*/
const getAllUnfilteredTags = createSelector(
  [allTags],
  (tags) => {
    const result = Array.from(tags);
    return result;
  }
);

export default getAllUnfilteredTags;



// WEBPACK FOOTER //
// ./src/utils/selectors/getAllUnfilteredTags.js